/*
 * brd-2026-designers.js
 * Per-section Swiper bootstrap for the Shop by Designer logo strip.
 * Mobile = 1-up, desktop = up to N-up (per_view_desktop schema setting).
 */
(function () {
  'use strict';

  function whenSwiperReady(cb, attempt) {
    attempt = attempt || 0;
    if (typeof window.Swiper === 'function') return cb();
    if (attempt > 200) return;
    setTimeout(function () { whenSwiperReady(cb, attempt + 1); }, 50);
  }

  function init(root) {
    if (!root || root.dataset.brdDesInit === '1') return;

    whenSwiperReady(function () {
      var swiperEl = root.querySelector('.brd-designers-swiper');
      if (!swiperEl) return;

      var perDesktop = parseInt(root.dataset.perDesktop, 10) || 4;
      var showArrows = root.dataset.showArrows === 'true';

      var instance = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          750:  { slidesPerView: Math.max(2, perDesktop - 1), spaceBetween: 16 },
          1100: { slidesPerView: perDesktop,                  spaceBetween: 20 }
        },
        navigation: showArrows ? {
          nextEl: root.querySelector('.brd-designers__arrow--next'),
          prevEl: root.querySelector('.brd-designers__arrow--prev')
        } : false,
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous designers',
          nextSlideMessage: 'Next designers'
        }
      });

      swiperEl.brdSwiper = instance;
      root.dataset.brdDesInit = '1';
    });
  }

  function bootAll() {
    document.querySelectorAll('.brd-designers[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.brd-designers[data-section-id]');
    if (s) init(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target.querySelector('.brd-designers[data-section-id]');
    if (!s) return;
    var swiperEl = s.querySelector('.brd-designers-swiper');
    if (swiperEl && swiperEl.brdSwiper && typeof swiperEl.brdSwiper.destroy === 'function') {
      swiperEl.brdSwiper.destroy(true, true);
      swiperEl.brdSwiper = null;
    }
  });
})();
